import { Expose, Type } from "class-transformer";
import type { BONUSX_SUBSCRIPTION_TIERS } from "../../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";
import type { DISCOUNT_UNIT } from "../../../../legacy/services/user-subscription/enums/discount-unit.enum";

export class UserSubscriptionDiscountDto {
  @Expose({ name: "amount" })
  discount!: number;

  @Expose({ name: "unit" })
  discountUnit!: DISCOUNT_UNIT;

  @Expose({ name: "item" })
  item!: string;
}

export class UserSubscriptionDto {
  @Expose()
  subscriptionTier!: BONUSX_SUBSCRIPTION_TIERS;

  @Expose()
  providerCode?: string;

  @Expose()
  startDate?: Date;

  @Expose()
  endDate?: Date;

  @Expose()
  cancelledAt?: Date;

  @Expose()
  @Type(() => UserSubscriptionDiscountDto)
  discounts: UserSubscriptionDiscountDto[] = [];
}
